import React, { useEffect } from 'react'
import { useDispatch } from 'APP/Hooks/redux'
import { zendeskActions } from 'APP/Store/Zendesk'
import Config from 'APP/Config'
import { logger } from 'APP/Lib/Datadog'

let zendeskInitialized = false

const ZendeskWidgetComponent: React.FC = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (zendeskInitialized) return

    const channelKey = Config.ZENDESK_WEB_CHANNEL_KEY
    if (!channelKey) {
      logger.error('[Zendesk] Missing ZENDESK_WEB_CHANNEL_KEY in Config')
      return
    }

    // Remove existing script if any
    const existingScript = document.getElementById('ze-snippet')
    if (existingScript) {
      document.body.removeChild(existingScript)
    }

    const script = document.createElement('script')
    script.id = 'ze-snippet'
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${channelKey}`
    script.async = true

    script.onload = () => {
      zendeskInitialized = true
      window.zE?.('messenger', 'hide')

      // Subscribe to unread messages
      window.zE?.('messenger:on', 'unreadMessages', (count: number) => {
        dispatch(zendeskActions.setUnreadCount(count))
      })

      window.zE?.('messenger:on', 'close', () => {
        window.zE?.('messenger', 'hide')
      })
    }

    document.body.appendChild(script)

    return () => {
      const zendeskScript = document.getElementById('ze-snippet')
      if (zendeskScript) document.body.removeChild(zendeskScript)
      zendeskInitialized = false
    }
  }, [dispatch])

  return null
}

export const initZendesk = async (): Promise<void> => {
  // No-op on web: initialization is handled by the ZendeskWidget component
}

export const logUnreadCount = async (): Promise<void> => {
  // No-op on web: unread count is managed by the ZendeskWidget component
  // via the 'unreadMessages' event listener
}

export const openZendesk = async (): Promise<void> => {
  // No-op on web: opening Zendesk is handled directly in HelpCentreScreen
  // using window.zE API calls
}

export const ZendeskWidget = React.memo(ZendeskWidgetComponent)
ZendeskWidget.displayName = 'ZendeskWidget'
